<template>
  <div class="text-center">
    <v-dialog persistent v-model="visible" width="900">
      <v-card class="not-margin pt-0 pr-0 pl-0">
        <v-toolbar dark color="primary">
          <div class="text-center">
            <v-icon>mdi-plus</v-icon> Adicionar Usuário(s)
          </div>
        </v-toolbar>
        <div class="container dialog">
          <v-row class="justify-center mt-7">
            <v-col cols="12">
              <v-text-field
                v-model="search"
                label="Buscar usuário"
                prepend-inner-icon="mdi-magnify"
                outlined
                dense
                clearable
                placeholder="Digite o nome ou CPF do usuário"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="justify-center">
            <v-col cols="12">
              <v-data-table
                v-model="usuariosSelecionados"
                :headers="headers"
                :items="form.lists.usuarios"
                :items-per-page="10"
                :search="search"
                :footer-props="$footerProps"
                show-select
                item-key="usuarioId"
              >
                <template v-slot:[`item.cpf`]="{ item }">
                  {{ $esconderCpf(item.cpf) }}
                </template>
                <template v-slot:top>
                  <div class="pa-2 d-flex align-center">
                    <v-checkbox
                      v-model="selecionarTodos"
                      label="Selecionar todos os usuários da página"
                      hide-details
                      class="mt-0"
                      @change="toggleSelecionarTodos"
                    ></v-checkbox>
                  </div>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </div>
        <sigfoco-buttons
          actionText="Adicionar Selecionados"
          @click="adicionarUsuarios()"
          @cancel="$emit('onClose')"
        ></sigfoco-buttons>
      </v-card>
    </v-dialog>
  </div>
</template>
  
<script>
import { DialogProps } from "~/commons/classes/dialog-props";
import ManterGrupoService from "~/services/manter-grupo.service";

export default {
  props: new DialogProps(Object),
  mixins: [ManterGrupoService],
  data: () => ({
    search: "",
    usuariosSelecionados: [],
    selecionarTodos: false,
    headers: [
      { text: "CPF", value: "cpf", sortable: true },
      { text: "Nome", value: "nome", sortable: true },
      { text: "Cargo/Função", value: "funcao", sortable: true },
    ],
    form: {
      lists: {
        usuarios: [],
      },
    },
  }),
  methods: {
    toggleSelecionarTodos() {
      if (this.selecionarTodos) {
        this.usuariosSelecionados = [...this.form.lists.usuarios];
      } else {
        this.usuariosSelecionados = [];
      }
    },
    adicionarUsuarios() {
      if (!this.usuariosSelecionados || this.usuariosSelecionados.length === 0) {
        return this.$notifyError("Por favor, selecione pelo menos um usuário.");
      }
      // Emitir todos os usuários selecionados
      this.usuariosSelecionados.forEach(usuario => {
        this.$emit("onSave", usuario);
      });
      // Limpar seleção após adicionar
      this.usuariosSelecionados = [];
      this.selecionarTodos = false;
      this.$emit('onClose');
    },
    buscarUsuarios() {
      this.$obterUsuariosGrupo().then(({ data }) => {
        this.form.lists.usuarios = data.usuarios;
      });
    }
  },
  watch: {
    usuariosSelecionados(val) {
      // Atualizar checkbox de "selecionar todos" baseado na seleção
      this.selecionarTodos = val.length === this.form.lists.usuarios.length && val.length > 0;
    }
  },
  mounted(){
    this.buscarUsuarios();
  }
};
</script>